import { Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from "@mui/material";
import styles from "./addlock.module.css";
import { Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useContext } from "react";
import { JobContext } from "../../../../../context/JobContext";

const AddLock = ({ setAddLockPopup, setLoading, addlockList, deviceDetails, setSnackbarMsg, setSnackbarOpen, onSubmitLocal }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [searchKey, setSearchKey] = useState("");
    const [selectProperty, setSelectProperty] = useState("");
    const [propertyList, setPropertyList] = useState([]);
    const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
    const [lockList, setLockList] = useState([]);
    const [allLockList, setAllLockList] = useState([]);

    const { setJobId, setProgress, setJobData } = useContext(JobContext);

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const fetchDeviceList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/device-lock-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setAllLockList(response.data.data);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        fetchDeviceList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (allLockList.length) {
            let tempDeviceList = allLockList;

            let lockIds = addlockList?.map(i => {
                return i?.device_id;
            });

            tempDeviceList = tempDeviceList?.filter(i => lockIds.indexOf(i?.id) === -1);

            if (searchKey !== '') {
                let inputVal = searchKey;
                inputVal = inputVal.toLowerCase();

                tempDeviceList = tempDeviceList.filter((item) => {
                    return (item?.name?.toLowerCase().includes(inputVal) || item?.real_name?.toLowerCase().includes(inputVal));
                });
            }

            if (selectProperty !== "" && selectProperty !== "all") {
                tempDeviceList = tempDeviceList.filter((i) => i.property_id === selectProperty);
            }


            setLockList(tempDeviceList);
        } else {
            setLockList([]);
        }

    }, [allLockList, addlockList, searchKey, selectProperty]);

    const AddLock = async () => {
        if (selectedDeviceIds.length === 0) {
            toast.error('Please select device.');
            return false;
        }

        let postData = { devices: selectedDeviceIds };
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs-new/" + deviceDetails?.id + "/add-lock", postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setAddLockPopup(false);

            setJobId(response?.data?.data?.id);
            setProgress(0);
            setJobData(response?.data?.data);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return <div className={`${styles.ModalFormGroup}`}>
        <div className={`${styles.AddDeviceSec}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
            </div>
            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Property*"
                        onChange={(e) => setSelectProperty(e.target.value)}
                    >
                        <MenuItem value="all">All</MenuItem>
                        {propertyList?.map((i) => {
                            return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
                        })}
                    </Select>
                </FormControl>
            </div>
        </div>
        <div className={`${styles.SelectAllSec}`}>
            {lockList?.length > 0 && <FormControlLabel className="CustomCheck"
                control={
                    <Checkbox
                        indeterminate={selectedDeviceIds?.length > 0 && lockList?.length !== selectedDeviceIds?.length}
                        checked={selectedDeviceIds?.length > 0 && lockList?.length === selectedDeviceIds?.length}
                        onChange={(e) => {
                            let selectedTemp = [];
                            if (e.target.checked) {
                                selectedTemp = lockList?.map(i => i?.deviceID)
                            }

                            setSelectedDeviceIds(selectedTemp);
                        }}
                    />
                }
                label="Select All Locks"
            />}
            <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>
        </div>
        <div className={`${styles.AddDeviceRow}`}>
            {lockList?.map((item, index) => {
                return (<div className={`${styles.AddDeviceList}`}>
                    <div className={`${styles.AddDeviceListUnder}`}>
                        <div className={`${styles.AddDeviceListHeadSec}`}>
                            <div className={`${styles.AddDeviceListIconSec}`}>
                                <img src="/static/img/Door.svg" width="24px" height="24px" alt="" />
                            </div>
                            <div className={`${styles.AddDeviceListTitleSec}`}>
                                <p className={`${styles.AddDeviceListTitleFirst}`}>Door Lock - <span>{item.apartment ? item.apartment.apt_no.slice(5) : item?.apt_text}</span></p>
                                <p className={`${styles.AddDeviceListTitle}`}>{item?.real_name}</p>
                            </div>
                        </div>
                        <div className={`${styles.ProspectCardFootSec} KeyFobChecklist`}>
                            <div className={`${styles.CustomCheck} CustomCheck`}>
                                <FormControlLabel style={{ margin: "0" }} control={
                                    <Checkbox
                                        onClick={(e) => { e.stopPropagation(); }}
                                        name={"id" + item?.deviceID}
                                        checked={selectedDeviceIds.indexOf(item?.deviceID) > -1}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedDeviceIds(prev => {
                                                    return prev.concat([item?.deviceID]);
                                                });
                                            } else {
                                                setSelectedDeviceIds(prev => {
                                                    return prev.filter(i => i !== item?.deviceID);
                                                });
                                            }
                                        }}
                                    />
                                } />
                            </div>
                        </div>
                    </div>
                </div>);
            })}
        </div>
        <div className={`${styles.ButtonAction}`}>
            <Button className="CancelPopupBU" onClick={(e) => setAddLockPopup(false)}>Cancel</Button>
            <Button className="SubmitPopupBU" onClick={(e) => AddLock()}>Add</Button>
        </div>
    </div>;
}

export default AddLock;